export var backdropColors = {pool:'#0593CA99',tennis:'#009B5599',hoops:'#C0472480',home:'#00000099',pickleball:'#04568D'};